import store from '@/shared/store'
import { acessaDashboard } from '@/shared/common/functions/dashboard'
import { possuiAtualizacoes } from '@/shared/common/functions/modalidade'

/**
 * Nas modalidades sem atualizações (Fiscal) estas telas não existem: o acesso
 * direto pela URL vai para o painel da própria modalidade, como qualquer
 * endereço fora da assinatura do cliente.
 *
 * A fonte aqui é a store porque o `beforeEach` global já esperou o
 * `usuarios/carregaUsuarioLogado` da autenticação; o `Vue.prototype` só recebe o
 * usuário no watch do `App.vue`, que roda depois.
 */
const validaModalidade = (to, from, next) => {
    const usuarioLogado = store.state.usuarios.usuarioLogado
    if (possuiAtualizacoes(usuarioLogado)) {
        return next()
    }
    const urlDashboard = (
        usuarioLogado
        && usuarioLogado.Modalidade
        && usuarioLogado.Modalidade.url_dashboard
    ) || '/inicio'
    acessaDashboard(urlDashboard)
}

const routes = [
    {
        path: '/',
        component: () => import('@/shared/components/layout/Interno'),
        children: [
            {
                name: 'listarAtualizacoes',
                path: '/atualizacoes',
                alias: '/atualizacoes/index',
                component: () => import('../views/Listar'),
                beforeEnter: validaModalidade
            },
            {
                name: 'visualizarAtualizacao',
                path: '/atualizacoes/visualizar/:id',
                component: () => import('../views/Visualizar'),
                beforeEnter: validaModalidade
            },
            
        ]
    }
]

export default routes
